import { useNavigate } from "react-router-dom";
import TableFilter from "./tableFilter";

function PhotoGallery() {
  const navigate = useNavigate();
  return (
    <>
      <div className="content-wrapper">
        <div
          className="content-heading d-flex
                          justify-content-between"
        >
          <div>Photo Gallery</div>
          <div>
            <button
              className="btn btn-labeled btn-success"
              type="button"
              style={{ fontSize: "17px" }}
              onClick={() => navigate("/admin/photo-gallery/new")}
            >
              <span className="btn-label">
                <em className="fas fa-plus"></em>
              </span>
              New Photo Gallery
            </button>
          </div>
        </div>
        <TableFilter />
      </div>
    </>
  );
}

export default PhotoGallery;
